import { useAppSelector } from "store"

export const getUserLinkedCloudsSelector = () => useAppSelector(state => state.otherClouds.clouds)

export const getAddOtherCloudModalStatusSelector = () => useAppSelector(state => state.otherClouds.addModalOpened)

export const getOtherCloudsLoadingStatuSelector = () => useAppSelector(state => state.otherClouds.status)